import React, { useState, useEffect } from "react";
import { IGlobalPoprop, IServiceData } from "../../interfaces/global-interface";
import { IEntradaInventario, EntradaInventarioError } from "../../interfaces/entrada-salida-interface";
import { getServiceData, postServiceData, saveServiceData } from "../../store/global-services";
import ButtonGST from "../../atoms/Controls/ButtonGTS";
import { StyledTableRow, StyledTableCell } from "../../atoms/tables/TableStyles";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Table, TableBody, TextField, TableContainer, TableHead, TableRow, FormControl, FormHelperText, InputLabel, Select, MenuItem, SelectChangeEvent, Stack, Pagination } from "@mui/material";
import { UrlSiteBase, formatDateFromStr } from '../../Global';
import { SwitchLabelGTS } from "../../atoms/Controls/SwitchGTS";
let { UrlBase } = UrlSiteBase();

const EntradaInventario = (globalProp?: IGlobalPoprop) => {
    const { idDistribuidora } = useParams();
    const { idEntrada } = useParams();
    const [ idEntradaState, setIdEntradaState ] = useState<number>(0);
    const [idDistEditar, setIdDisEditar] = useState<string>(idDistribuidora || '0');
    const [productos, setProductos] = useState<any>([]);
    const [idTipoEntrada, setIdTipoEntrada] = useState<string>('0');
    const [entrada, setEntrada] = useState<IEntradaInventario>();
    const [tiposEntrada, setTiposEntrada] = useState<any>([]);
    const [observaciones, setObservaciones] = useState<string>('');
    const [motivoCancelacion, setMotivoCancelacion] = useState<string>('');
    const [isActive, setIsActive] = useState<boolean>(idEntrada ? (entrada?.estatus === 1 ? true : false) : true);
    const [error, setError] = useState(EntradaInventarioError);
    const [page, setPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [prodCache, setProdCache] = useState<any>([]);

    const navigate = useNavigate();
    const getProductosInventario = (page: number) => {
        if (idDistribuidora == undefined) return;
        if (tiposEntrada.length === 0) 
            return;
        let dataService: IServiceData  = { nombre: 'productos/inventario' };
        let paramService = {};
        if (page > 1) 
            paramService = { ...paramService, 'page': page };
        paramService = { ...paramService, 'estatus': 1, 'idDistribuidora': idDistribuidora };
        dataService = { ...dataService, 'parametros': paramService };
        getServiceData(dataService).then(data => {
            if (data.success) {
                setProductos(data.productos);
                setTotalPages(data.pagination.last_page);
            }
        });
    }
    const getEntradaInventario = () => {
        if (idEntrada !== undefined)
            setIdEntradaState(parseInt(idEntrada, 10));
        if (tiposEntrada.length === 0) 
            return;
        getServiceData({ 
            nombre: 'entrada-inventario', 
            id: idEntradaState.toString(),
            parametros: idDistribuidora === undefined ? {} : { idDistribuidora: idDistribuidora }
        }).then(data => {
            if (data.success) {
                setIdDisEditar(data.entrada.idDistribuidora);
                setIdTipoEntrada(data.entrada.idTipoEntrada);
                setObservaciones(data.entrada.observaciones);
                setMotivoCancelacion(data.entrada.motivoCancelacion || '');
                setIsActive(data.entrada.estatus === 1);
                if (data.entrada.id > 0) {
                    data.entrada.productos.forEach((prod: any) => {
                        prod.nombre = prod.producto;
                        prod.errorCantidadContenedor = '';
                        prod.cantidadContenedor = prod.cantidadContenedor || 0;
                        prod.cantidadSuelta = prod.cantidadSuelta || 0;
                        setCantidadEmpaqueTotal(prod);
                    });
                    setProductos(data.entrada.productos);
                }
                setEntrada(data.entrada);
            }
        });
    }
    const getTiposEntrada = () => {
        getServiceData({ nombre: 'tipos-entrada' }).then(data => {
            if (data.success) {
                setTiposEntrada(data.tiposEntradas);
            }
        });
    };
    useEffect(() => {
        getTiposEntrada();
    }, []);
    useEffect(() => {
        getProductosInventario(page);
        getEntradaInventario();
    }, [tiposEntrada, page]);

    // Sumar contenedor
    const setProductAddInvContenedor = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>,row: any) => {
        event.stopPropagation();
        row.cantidadContenedor = (row.cantidadContenedor || 0) + 1;
        setCantidadEmpaqueTotal(row);
        setProductos([...productos]);
    };

    // Restar contenedor
    const setProductRestInvContenedor = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, row: any) => {
        event.stopPropagation();
        if (row.cantidadContenedor && row.cantidadContenedor > 0) {
            row.cantidadContenedor = row.cantidadContenedor - 1;
            setCantidadEmpaqueTotal(row);
            setProductos([...productos]);
        }
    };
    const setCantidadEmpaqueTotal = (row: any) => {
        row.cantidadEmpaqueTotal = (row.cantidadContenedor || 0) * row.capacidadContenedor + (row.cantidadSuelta || 0);
        setProdCache({ ...prodCache, [row.id]: row });// Cache the product to avoid recalculating
    };
    // Sumar sueltos
    const setProductAddInvSuelto = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, row: any) => {
        row.cantidadSuelta = (row.cantidadSuelta || 0) + 1;
        setCantidadEmpaqueTotal(row);
        setProductos([...productos]);
    };

    // Restar sueltos
    const setProductRestInvSuelto = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, row: any) => {
        event.stopPropagation();
        if (row.cantidadSuelta && row.cantidadSuelta > 0) {
            row.cantidadSuelta = row.cantidadSuelta - 1;
            setCantidadEmpaqueTotal(row);
            setProductos([...productos]);
        }
    };
    const getProdCache = (id: number, row: any) => {
        return prodCache[id] || row;
    };
    const handleProductInvContenedor = (value: string, row: any) => {
        const cantidad = parseInt((value || "0"), 10);
        if (!isNaN(cantidad)) {
            row.cantidadContenedor = cantidad;
            setCantidadEmpaqueTotal(row);
            setProductos([...productos]);
        }
    };
    const handleProductInvSuelto = (value: string, row: any) => {
        const cantidad = parseInt((value || "0"), 10);
        if (!isNaN(cantidad)) {
            row.cantidadSuelta = cantidad;
            setCantidadEmpaqueTotal(row);
            setProductos([...productos]);
        }
    };
    const handleSelectChange = (event: SelectChangeEvent<string>) => {
        const { name, value } = event.target;
        setIdTipoEntrada(value);
        setError(error => ({ ...error, [name]: '' })); // Reset error for idTipoEntrada
    };
    const handleInputTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = event.target;
        setObservaciones(value);
        setError(error => ({ ...error, [id]: '' })); // Reset error for observaciones
    }
    const handleInputTextChangeCancela = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = event.target;
        setMotivoCancelacion(value);
        setError(error => ({ ...error, [id]: '' })); // Reset error for motivoCancelacion
    };
    const handleCheckbox = () => {
        setIsActive(!isActive);
        if (isActive === false){
            if (globalProp && globalProp.snackHandleOpen) {
                globalProp.snackHandleOpen({ open: true, message: 'Si cancelas esta entrada, los productos se descontaran del inventario.', color: 'orange' });
            }
        }
    }
    const handlePaginationChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };
    const guardarEntradaInv = () => {
        let numProdEntrada = 0;
        let prodsToSave = Object.values(prodCache);
        prodsToSave.forEach((prod: any) => {
            if (prod.cantidadContenedor > 0 || prod.cantidadSuelta > 0) {
                numProdEntrada++;
            }
        });
        if (numProdEntrada === 0) {
            if (globalProp && globalProp.snackHandleOpen)
                globalProp.snackHandleOpen({ open: true, message: 'Debe agregar al menos un producto a la entrada de inventario.', color: 'red' });
            return;
        }
        saveServiceData({ reqMethod: 'PUT', nombre: 'entrada-inventario', datos : 
            { 
                id: idEntradaState ?? 0,
                idDistribuidora: idEntradaState === 0 ? idDistribuidora : entrada?.idDistribuidora,
                idTipoEntrada: idTipoEntrada,
                observaciones: observaciones,
                motivoCancelacion: isActive ? null : motivoCancelacion,
                estatus: isActive ? 1 : 2,
                'productos': prodsToSave.filter((prod: any) => prod.cantidadContenedor > 0 || prod.cantidadSuelta > 0)
            }
        }).then((data) => {
            if (data.success) {
                navigate(UrlBase + 'Entrada-Inventario');
                if (globalProp && globalProp.snackHandleOpen)
                    globalProp.snackHandleOpen({ open: true, message: data.message });
            }
            else {
                setError(EntradaInventarioError);
                for (const [key, value] of Object.entries(data.message)) {
                    setError(error => ({...error, [key]: value}));
                }
            }
        });
    };
    const getSafeValue = (field: any) => {
        return field === undefined || field === null ? '' : field;
    };
    return (
        <>
            <Box className="form-gst maximum" component="form" noValidate autoComplete="off">
                <div className="panel-inputs">
                    <div className="d-inline-flex p-2">
                        <div>
                            <div className="label">Distribuidora: {entrada?.distribuidora}</div>
                            <div className="label">Usuario: {entrada?.usuario}</div>
                        </div>
                    </div>
                    {idEntradaState > 0 ? 
                        <div className="d-inline-flex p-2">
                            <div>
                                <div className="label">Fecha de entrada al inventario: { formatDateFromStr(entrada?.fecha + "")}</div>
                                <FormControl className="check-control" error={error.estatus !== ''}>
                                    <SwitchLabelGTS label={isActive ? "Activo" : "Cancelado"} id="estatus" checked={isActive} onChange={handleCheckbox} />
                                </FormControl>
                            </div>
                        </div>
                        : <></>
                    }
                    <FormControl className="select-control">
                        <InputLabel id="perfil-label">Tipo de entrada</InputLabel>
                        <Select labelId="tipo-entrada" id="tipo-entrada" name="idTipoEntrada" value={idTipoEntrada} label="Tipo de entrada" onChange={handleSelectChange}>
                            <MenuItem value={0}>Seleccione un tipo de entrada</MenuItem>
                            {tiposEntrada?.map((tipoEntrada: any) => (
                                <MenuItem key={tipoEntrada.id} value={tipoEntrada.id}>{tipoEntrada.nombre}</MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>{error.idTipoEntrada}</FormHelperText>
                    </FormControl>
                    
                    <TextField id="observaciones" className="medium-textarea" onChange={handleInputTextChange} multiline rows={2}
                            value={getSafeValue(observaciones)} label="Observaciones" color="secondary" error={error.observaciones !== ''}  helperText={error.observaciones} />
                    {idEntradaState > 0 && !isActive ? 
                        <>
                            <div className="d-inline-flex">
                                <div>
                                    <TextField id="motivoCancelacion" className="medium-textarea" onChange={handleInputTextChangeCancela} multiline rows={2}
                                        value={getSafeValue(motivoCancelacion)} label="Motivo de Cancelación" color="secondary" error={error.motivoCancelacion !== ''}  helperText={error.motivoCancelacion} />
                                </div>
                            </div>
                            {entrada?.fechaCancela ? 
                                <div className="d-inline-flex">
                                    <div>
                                        <div className="label">Fecha de cancelación: { formatDateFromStr(entrada?.fechaCancela + "")}</div>
                                    </div>
                                </div> 
                                : <></>}
                        </>
                    : <></>}
                </div>
            </Box>
            <TableContainer>
                <Table className="table-gts product-table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>ID</StyledTableCell>
                            <StyledTableCell>Producto</StyledTableCell>
                            <StyledTableCell align="center">Cantidad Contenedor</StyledTableCell>
                            <StyledTableCell align="center">Capacidad Contenedor</StyledTableCell>
                            <StyledTableCell align="center">Empaques Sueltos</StyledTableCell>
                            <StyledTableCell align="center">Empaques Totales</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {productos?.map((row: any) => (
                            <StyledTableRow key={row.id}>
                                <StyledTableCell>{row.id}</StyledTableCell>
                                <StyledTableCell>{row.nombre}</StyledTableCell>
                                <StyledTableCell align="center">
                                    {idEntrada === undefined ? (
                                        <div className="controls">
                                            <button className="add-product" onClick={(event) => setProductAddInvContenedor(event, row)}>+</button>
                                            <TextField className="input-cantidad" value={getProdCache(row.id, row)?.cantidadContenedor} error={row?.errorCantidadContenedor !== ''}  helperText={row?.errorCantidadContenedor} onChange={(event) => handleProductInvContenedor(event.target.value, row)} />
                                            <button className="minus-product" onClick={(event) => setProductRestInvContenedor(event, row)} >-</button>
                                        </div>
                                    ) : (
                                        <div>{row?.cantidadContenedor}</div>
                                    )}
                                </StyledTableCell>
                                <StyledTableCell align="center">{row?.capacidadContenedor}</StyledTableCell>
                                <StyledTableCell align="center">
                                    {idEntrada === undefined ? (
                                        <div className="controls">
                                            <button className="add-product" onClick={(event) => setProductAddInvSuelto(event, row)}>+</button>
                                            <TextField className="input-cantidad" value={getProdCache(row.id, row)?.cantidadSuelta} error={row?.errorCantidadSuelta !== ''}  helperText={row?.errorCantidadSuelta} onChange={(event) => handleProductInvSuelto(event.target.value, row)} />
                                            <button className="minus-product" onClick={(event) => setProductRestInvSuelto(event, row)} >-</button>
                                        </div>
                                    ) : (
                                        <div>{row?.cantidadSuelta}</div>
                                    )}
                                </StyledTableCell>
                                <StyledTableCell align="center">{getProdCache(row.id, row)?.cantidadEmpaqueTotal}</StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            { totalPages > 1 ?
                <Stack spacing={2}>
                    <Pagination count={totalPages} page={page} onChange={handlePaginationChange} />
                </Stack> 
                : <></>
            }
            <div className="panel-actions align-right">
                <ButtonGST onClick={() => navigate(UrlBase + 'Entrada-Inventario')}>{idEntradaState > 0 ? 'Cancelar Edición' : 'Cancelar Entrada'}</ButtonGST>
                {entrada?.estatus === 1 && <ButtonGST onClick={guardarEntradaInv}>Guardar</ButtonGST>}
            </div>
        </>
    );
};
export default EntradaInventario;